var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "emailValidation" },
    [
      _c(
        "md-card-content",
        [
          _c(
            "div",
            { staticClass: "flex justify-center" },
            [
              _c("font-awesome-icon", {
                staticClass: "text-primary",
                attrs: { icon: ["fas", "envelope-circle-check"], size: "5x" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex justify-center mt-3 mb-3" }, [
            _c("span", {
              staticClass: "text-lg font-bold text-primary-dark-100",
              domProps: {
                innerHTML: _vm._s(_vm.$t("registration.validate-email.title"))
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "text-base text-center text-primary-dark-100" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("registration.validate-email.description", {
                      email: _vm.email
                    })
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-center mt-4" },
            _vm._l(_vm.code, function(ch, i) {
              return _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code[i],
                    expression: "code[i]"
                  }
                ],
                key: i,
                ref: "code" + i,
                refInFor: true,
                staticClass:
                  "block w-10 mr-2 bg-white border border-gray-200 text-primary-dark-100 text-sm rounded-md block p-1.5 text-center",
                attrs: {
                  type: "text",
                  maxlength: "1",
                  autocomplete: "one-time-code",
                  inputmode: "numeric",
                  disabled: _vm.loading
                },
                domProps: { value: _vm.code[i] },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.code, i, $event.target.value)
                    },
                    function($event) {
                      _vm.onInput(i, $event)
                    }
                  ],
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k(
                        $event.keyCode,
                        "backspace",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    _vm.onBackspace(i, $event)
                  },
                  paste: function($event) {
                    _vm.onPaste(i, $event)
                  }
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          !!_vm.showError
            ? _c("div", {
                staticClass: "my-2 text-center text-xs text-red-500",
                domProps: { innerHTML: _vm._s(_vm.message) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 text-center cursor-pointer" }, [
            _c(
              "a",
              {
                staticClass: "text-xs !text-primary-dark-100 !underline ",
                on: { click: _vm.sendEmailCode }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("registration.validate-email.resend-code"))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 text-center" }, [
            _c("a", { staticClass: "text-xs !text-primary-dark-100" }, [
              _vm._v(
                _vm._s(_vm.$t("registration.validate-email.check-in-spam"))
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "md-snackbar",
            {
              attrs: { "md-active": _vm.showSnackbar },
              on: {
                "update:mdActive": function($event) {
                  _vm.showSnackbar = $event
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.message)))])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00fb8520", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00fb8520","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/emailValidation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-00fb8520","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/emailValidation.vue
// module chunks = 1 2 3